import React, { useState, useContext } from 'react';
import Grid from '@mui/material/Grid';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import CustomRowLabels from './CustomRowLabels';

import HeaderSubSection from './HeaderSubSection';

import { ChillerLogsContext } from '../contexts/ChillerLogsContext';

interface HeaderSectionProps {}

const HeaderSection: React.FunctionComponent<HeaderSectionProps> = () => {
  let { chillerLog, prevChillerLog1, prevChillerLog2 } = useContext(ChillerLogsContext);

  let [expanded, setExpanded] = useState(true);

  const hasPreviousChillerLog1 = prevChillerLog1?.header_details?.length > 0;
  const hasPreviousChillerLog2 = prevChillerLog2?.header_details?.length > 0;

  return (
    chillerLog && (
      <Accordion expanded={expanded} onChange={() => setExpanded(!expanded)}>
        <AccordionSummary style={{ background: '#A21C37' }}>
          <h3 style={{ color: '#fff', fontWeight: 700 }}>{chillerLog?.chiller_type_label} Cooled Unit</h3>
        </AccordionSummary>
        <AccordionDetails style={{ margin: 0, padding: 0 }}>
          <Grid container display={{ display: 'flex', justifyContent: 'flex-start' }}>
            <Grid item xs={2}>
              <CustomRowLabels data={chillerLog?.header_details} />
            </Grid>
            {hasPreviousChillerLog2 && (
              <Grid item xs={1}>
                <HeaderSubSection sectionChillerLog={prevChillerLog2} col={1} />
              </Grid>
            )}
            {hasPreviousChillerLog1 && (
              <Grid item xs={1} style={{ marginLeft: hasPreviousChillerLog2 ? '-20px' : 0 }}>
                <HeaderSubSection sectionChillerLog={prevChillerLog1} col={2} />
              </Grid>
            )}
            <Grid item xs={1} style={{ marginLeft: hasPreviousChillerLog1 ? '-20px' : 0 }}>
              {chillerLog?.header_details?.length > 0 && <HeaderSubSection sectionChillerLog={chillerLog} col={3} />}
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    )
  );
};

export default HeaderSection;
